export enum ServiceClusterType {
    Repairs = "Repairs",
    Tyres = "Tyres",
    Glass = "Glass",
    Prepurchase = "Prepurchase",
    Servicing = "Servicing",
}